import { reportError } from './diagnostics';
export class ApiError extends Error {
  constructor(
    message: string,
    public code?: string,
    public status?: number,
  ) {
    super(message);
  }
}
export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch('/api' + path, {
    credentials: 'include',
    ...options,
    headers: {
      ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
      ...options.headers,
    },
  });
  const data = await response.json().catch(() => ({}));
  if (response.status >= 500 && !path.startsWith('/diagnostics') && !path.startsWith('/admin/diagnostics')) reportError(new Error(`接口 ${path.split('?')[0]} 返回 ${response.status} · 请求 ${response.headers.get('X-Request-Id') || 'unknown'}`),'platform-api');
  if (!response.ok) throw new ApiError(data.error || '网络连接失败', data.code, response.status);
  return data as T;
}
export const json = (method: string, body: unknown): RequestInit => ({
  method,
  body: JSON.stringify(body),
});
export const bytes = (n: number) =>
  n < 1024 * 1024
    ? `${Math.max(1, Math.round(n / 1024))} KB`
    : `${(n / 1024 / 1024).toFixed(1)} MB`;
export const date = (value: string) => new Date(value).toLocaleDateString('zh-CN');

export function uploadWithProgress<T>(
  path: string,
  body: FormData,
  onProgress: (value: number) => void,
  signal?: AbortSignal,
) {
  return new Promise<T>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const abort = () => xhr.abort();
    const cleanup = () => signal?.removeEventListener('abort', abort);
    xhr.open('POST', '/api' + path);
    xhr.withCredentials = true;
    xhr.timeout = 10 * 60000;
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) onProgress(Math.round((event.loaded / event.total) * 100));
    };
    xhr.onload = () => {
      cleanup();
      try {
        const data = JSON.parse(xhr.responseText);
        xhr.status >= 200 && xhr.status < 300
          ? resolve(data)
          : reject(new Error(data.error || '上传失败'));
      } catch {
        reject(new Error('上传响应异常，请重试'));
      }
    };
    xhr.onerror = () => {
      cleanup();
      reject(new Error('上传中断，请检查网络后重试'));
    };
    xhr.ontimeout = () => {
      cleanup();
      reject(new Error('上传超时，请稍后重试'));
    };
    xhr.onabort = () => {
      cleanup();
      reject(new DOMException('已取消上传', 'AbortError'));
    };
    if (signal?.aborted) {
      reject(new DOMException('已取消上传', 'AbortError'));
      return;
    }
    signal?.addEventListener('abort', abort, { once: true });
    xhr.send(body);
  });
}
